import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTemperatureHigh, faTint, faCloud } from '@fortawesome/free-solid-svg-icons';
import '../styles/styles.css';

const CurrentWeather = ({ latitude, longitude, searchQuery }) => {
  const [weatherData, setWeatherData] = useState(null);

  useEffect(() => {
    const fetchWeatherData = async () => {
      try {
        const apiKey = '06d84e72e3bcfb924f9c0960f08cb4b5';
        let apiUrl = `https://api.openweathermap.org/data/2.5/weather?appid=${apiKey}`;

        if (searchQuery) {
          apiUrl += `&q=${searchQuery}`;
        } else {
          apiUrl += `&lat=${latitude}&lon=${longitude}`;
        }

        const response = await fetch(apiUrl);
        const data = await response.json();

        setWeatherData(data);
      } catch (error) {
        console.error('Error fetching current weather:', error);
        // Handle error if weather data retrieval fails
      }
    };

    fetchWeatherData();
  }, [latitude, longitude, searchQuery]);

  if (!weatherData) {
    return <div>Loading current weather...</div>;
  }

  const { name, main, weather } = weatherData;
  const temperatureInCelsius = Math.round(main.temp - 273.15);

  return (
    <div className="max-w-10xl bg-black bg-opacity-40 rounded-lg p-4">
      <h2 className="text-5xl font-semibold text-white mb-2">Current Weather in {name}</h2>
      <div className="max-w-10xl flex flex-wrap gap-8 ">
        <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 mb-4">
          <div className="bg-black bg-opacity-60 rounded-lg p-3">
            <div className="flex items-center">
              <FontAwesomeIcon icon={faTemperatureHigh} className="text-3xl text-red-700 mr-2" />
              <span className="text-xl text-white">Temp :</span>
              <span className="text-xl text-white">{temperatureInCelsius}°C</span>
            </div>
          </div>
        </div>
        <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/3 mb-4">
          <div className="bg-black bg-opacity-50 rounded-lg p-3">
            <div className="flex items-center">
              <FontAwesomeIcon icon={faTint} className="text-3xl text-blue-700 mr-2" />
              <span className="text-xl text-white">Humidity :</span>
              <span className="text-xl text-white">{main.humidity}%</span>
            </div>
          </div>
        </div>
        <div className="w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-7">
          <div className="bg-black bg-opacity-50 rounded-lg p-2">
            <div className="flex items-center">
              <FontAwesomeIcon icon={faCloud} className="text-4xl text-yellow-400 mr-3" />
              <span className="text-xl text-white">Weather :</span>
              <span className="text-xl text-white">{weather[0].description}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentWeather;
